import { useTranslation } from "react-i18next";
import { FiFile } from "react-icons/fi";
import { ViewDocumentAsOwnerDto, useGetBuyerSupplierInformationQuery } from "../../../autogen/bff-api";
import { collectPublishedDocuments } from "../../../common/components/communication/publishedDocuments";
import { DocumentsAsOwnerTable } from "../../../common/documents/DocumentsAsOwnerTable";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

export const DocumentsSection = ({ eventId, documents }: { eventId: string; documents: ViewDocumentAsOwnerDto[] }) => {
  const { t } = useTranslation();
  const { data: announcementsData } = useGetBuyerSupplierInformationQuery({ eventId });
  const publishedDocuments = collectPublishedDocuments(
    announcementsData?.supplierInformation ?? [],
    documents.map((d) => d.id),
  );
  const restrictedDocumentIds = new Set(publishedDocuments.map((d) => d.id));
  const rows = [...documents, ...publishedDocuments];
  return (
    <SectionCard icon={FiFile} title={t("Documents")} count={rows.length}>
      <DocumentsAsOwnerTable documents={rows} restrictedDocumentIds={restrictedDocumentIds} eventId={eventId} />
    </SectionCard>
  );
};
